<template>
  <div class="product-index-box" v-loading="loading">
    <div class="task-head-stage is-deleted" v-if="delete_time">
      <p>
        产品项已在回收站，不可编辑。
        <template v-if="$permission('产品项管理-更新产品项')">
          点击
          <span class="recovery" @click="handleRecover">恢复</span>
        </template>
      </p>
    </div>
    <div class="top-box">
      <Banner :restFirst="product_series.series_name"></Banner>
    </div>
    <div class="content">
      <Photo v-if="form.images && form.images.length > 0" v-model="form.images" disabled></Photo>
      <div class="normal-imgs" v-else>
        <img src="image/product/bg_product@2x.png" alt="">
        <toolTip style="width: 80%;" maxWidth="auto" class="name" :title="form.product_name">
          <span>{{ form.product_name }}</span>
        </toolTip>
      </div>
      <div class="cell">
        <div class="h-1">
          <div class="title">{{form.product_name}}</div>
          <el-popover trigger="click" placement="right" :offset="50" v-model="visible" popper-class="product-index-box--popover">
            <div class="select-box">
              <span :class="`select-box-${item.value} bgActive`" v-for="item in handleData" :key="item.value" @click="handlerClick(item.value)" v-if="!item.visible || (item.visible && item.visible())">
                <i :class="`icon iconfont ${item.icon}`"></i>
                <a v-if="item.value !== 'line'">{{item.label}}</a>
              </span>
            </div>
            <div class="project-name " slot="reference">
              <i class="icon iconfont iconicon_user_more_task tableIconHover"></i>
            </div>
          </el-popover>
        </div>
        <div class="h-2">
          <span :class="tag.class"></span>
          <span class="h-2-tag">{{ product_series.series_name }}</span>
        </div>
        <div class="h-3">{{form.highlights}}</div>
        <div class="h-4" v-if="form.description">
          <div class="little">产品概述</div>
          <div>{{ form.description }}</div>
        </div>
        <div class="h-4" v-if="form.status_description">
          <div class="little">产品状态</div>
          <div>{{form.status_description}}</div>
        </div>
      </div>
    </div>
    <div class="h-5" v-if="projectInfo.length > 0">
      <div class="title">关联项目<span>{{projectInfo.length}}</span></div>
      <div class="content">
        <ProjectItem v-for="(item, index) in projectInfo" :key="index" :projectInfo="item" @click.native="viewProject(item)"></ProjectItem>
      </div>
    </div>
    <div class="h-6" v-if="form.create_project_attachments && form.create_project_attachments.length > 0">
      <div class="title">产品立项文件</div>
      <div class="content">
        <File v-for="(item, index) in form.create_project_attachments" :key="index" :file="item"></File>
      </div>
    </div>
    <div class="h-6" v-if="form.information_attachments && form.information_attachments.length > 0">
      <div class="title">产品资料文件</div>
      <div class="content">
        <File v-for="(item, index) in form.information_attachments" :key="index" :file="item"></File>
      </div>
    </div>
    <div class="h-4-1" v-if="form.remark">
      <div class="little">备注</div>
      <div>{{form.remark}}</div>
    </div>
    <UpdateDialog v-model="updateDialogVisible" :id="form.id"></UpdateDialog>
    <RecycleDialog v-model="recycleDialogVisible" :id="form.id"></RecycleDialog>
    <DelDialog v-model="delDialogVisible" :id="form.id" @success="delSuccess" title="删除产品项"></DelDialog>
  </div>
</template>
<script>
import Banner from '@/components/banner'
import Photo from './components/photo'
import ProjectItem from './components/projectItem'
import File from './components/file'
import UpdateDialog from './components/updateDialog'
import RecycleDialog from './components/recycleDialog'
import DelDialog from './components/delDIalog'
import api from '@/services/api/product/product'
import { mapState } from 'vuex'
export default {
  components: { Banner, Photo, ProjectItem, File, UpdateDialog, RecycleDialog, DelDialog },
  data() {
    return {
      form: {
        product_name: '',
        development_status: '',
        product_series_id: '',
        highlights: '',
        create_project_attachments: [],
        information_attachments: [],
        images: Array.from({ length: 9 }, (_, i) => { return {} }),
        description: '',
        status_description: '',
        updated_reason: '',
        remark: '',
        updated_reason_attachments: [],
        id: ''
      },
      handleData: [],
      handleDataCopy:  [{
        label: '编辑',
        icon: 'iconicon_input',
        value: 'edit',
        visible: () => {
          return this.$permission('产品项管理-更新产品项')
        }
      },
      {
        label: '更新记录',
        icon: 'iconicon_log1',
        value: 'update',
        show: true
      },
      {
        label: '回收站',
        icon: 'iconicon_recycle',
        value: 'bin',
        show: true
      },
      {
        label: 'line',
        value: 'line',
      },
      {
        label: '删除',
        icon: 'iconicon_recycle_bin',
        value: 'delete',
      }],
      visible: false,
      projectInfo: [],
      updateDialogVisible: false,
      recycleDialogVisible: false,
      delDialogVisible: false,
      delete_time: '',
      loading: true,
      product_series: {}
    }
  },
  computed: {
    ...mapState('product/product', {
       filterList: state => state.filterList.filter(res => res.value !== 0),
       series_name: state => state.series_name
    }),
    tag() {
      return this.filterList.find(res => res.value === this.form.development_status) || this.filterList[0] || {}
    }
  },
  watch: {
    '$route.query':{
      handler() {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // this.init()
  },
  methods: {
    handlerClick(val) {
      switch (val) {
        case 'edit':
          this.$router.push(`/productDataAdd?id=${this.form.id}`)
          break
        case 'update':
          this.updateDialogVisible = true
          break
        case 'bin':
          this.recycleDialogVisible = true
          break
        case 'delete':
          this.del()
          break
      }
    },
    async init() {
      this.loading = true
      let result = await api.productSeriesIndex({ page: 1, per_page: 999 })
      this.seriesList = result.data || []

      let { product_name, development_status, product_series_id, highlights, create_project_attachments, information_attachments, images, description, status_description, remark, product_series, product_projects, id, delete_time } =
        await api.productsRead({ id: this.$route.query.id})
      this.form.product_name = product_name
      this.form.development_status = development_status
      this.form.product_series_id = product_series_id
      this.form.highlights = highlights
      this.form.create_project_attachments = create_project_attachments ? Object.entries(create_project_attachments).map(([key, value]) => value).sort((a, b) => a.sort - b.sort) : []
      this.form.information_attachments = information_attachments ? Object.entries(information_attachments).map(([key, value]) => value).sort((a, b) => a.sort - b.sort) : []
      this.form.images = images ? [...Object.entries(images).map(([key, value]) => value), ...Array.from({ length: 9 }, (_, i) => { return {} })].slice(0, 9).sort((a, b) => a.sort - b.sort) : []
      this.form.description = description
      this.form.status_description = status_description
      this.form.remark = remark
      this.form.id = id
      this.product_series = product_series
      this.projectInfo = product_projects
      this.delete_time = delete_time
      if (delete_time) {
        this.handleData = this.handleDataCopy.filter(res => res.show)
      } else {
        this.handleData = this.handleDataCopy
      }
      this.loading = false
    },
    async del() {
      this.delDialogVisible = true
      // await this.$wfAlert('warning', '确认删除吗?', '', '删除', 'warning')
      // await api.productsDelete({ id: this.form.id })
      // this.$message({
      //   message: '删除成功',
      //   type: 'success'
      // })
      // this.$router.go(-1)
    },
    delSuccess() {
      this.$router.go(-1)
    },
    viewProject(itemData) {
      if(itemData.join_project_permission) return
      this.$router.push({
        path: "/task",
        query: {
          projectId: itemData.project_id,
          isTabShow: true
        }
      })
    },
    async handleRecover() {
      await this.$wfAlert('warning', `确认恢复产品项？`, '', '确认')
      await api.productsRestoreProduct({ id: this.form.id })
      this.$message({
        message: `恢复产品项成功`,
        type: 'success'
      })
      this.init()
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.product-index-box--popover {
  .select-box {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    padding: 8px 0;
    span {
      display: flex;
      align-items: center;
      height: 40px;
      padding: 0 16px;
    }
    i {
      margin-right: 8px;
    }
    .select-box-line {
      height: 1px;
      border-top: 1px solid #E5E6E8;
      margin: 8px 0;
    }
  }
}
.product-index-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  .task-head-stage {
      width: 100%;
      height: 48px;
      @include bgColorOpacity(.08);
      p {
        text-align: center;
        line-height: 48px;
        @include fontColorOpacity(.8);
        .recovery {
          cursor: pointer;
          margin-left: 8px;
          color: #2682FF;
          text-decoration: underline;
        }
      }
    }
  .top-box {
    width: 100%;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
  }
  >.content {
    display: flex;
    margin-bottom: 30px;
    margin-top: 24px;
    .normal-imgs {
      width: 540px;
      height: 360px;
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      .name {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-weight: 500;
        font-size: 28px;
        color: #FFFFFF;
        text-align: center;
      }
    }
    .cell {
      display: flex;
      flex-direction: column;
      width: 610px;
      padding-left: 24px;
      .h-1 {
        display: flex;
        align-items: center;
        .title {
          font-size: 32px;
          font-weight: 500;
          margin-right: 23px;
        }
        .project-name i{
          font-size: 24px;
          color: #797979;
        }
      }
      .h-2 {
        display: flex;
        align-items: center;
        margin-top: 16px;
        grid-gap: 8px;
        .h-2-tag {
          background-color: #DBDBDB;
          border-radius: 4px;
          padding: 0 16px;
          display: flex;
          align-items: center;
        }
        span {
          height: 28px !important;
          &::before {
            height: 28px !important;
          }
        }
      }
      .h-3 {
        line-height: 20px;
        margin-top: 24px;
        white-space: pre-wrap;
      }
      .h-4 {
        margin-top: 32px;
        line-height: 20px;
        font-size: 14px;
        * {
          white-space: pre-wrap;
        }
      }

      .little {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 16px;
      }

    }
  }
  .h-4-1 {
    margin-top: 32px;
    line-height: 20px;
    font-size: 14px;
    width: 1180px;
    * {
      white-space: pre-wrap;
    }
  }
  .h-5 {
    width: 1259px;
    .title {
      font-size: 18px;
      font-weight: 500;
      text-align: left;
      padding-left: 40px;
      padding-right: 40px;
      span {
        font-size: 14px;
        color: rgba(32, 32, 32, 0.60);
        margin-left: 8px;
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      grid-gap: 16px;
      padding-top: 16px;
      padding-bottom: 30px;
      max-height: 268px;
      overflow-y: auto;
      overflow-x: visible;
      padding-left: 40px;
      padding-right: 40px;
    }
  }
  .h-box {
    display: flex;
    justify-content: space-between;
    width: 1180px;
    padding-right: 11px;
    box-sizing: border-box;
  }
  .h-6 {
    width: 1180px;
    .title {
      font-size: 18px;
      font-weight: 500;
      text-align: left;
      span {
        font-size: 14px;
        color: rgba(32, 32, 32, 0.60);
        margin-left: 8px;
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      gap: 8px 0;
      margin-top: 16px;
    }
    & + .h-6 {
      margin-top: 24px;
    }
  }
}
</style>
